/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  daysLeft: {
    id: 'components.header.trial.daysLeft',
    defaultMessage: '{daysLeft, plural, one {# day left} other {# days left}}'
  }
});

export const TaskMessages = defineMessages({
  actions: {
    id: 'components.onboarding.tasks.actions',
    defaultMessage: 'Build actions'
  },
  actionsDesc: {
    id: 'components.onboarding.tasks.actionsDesc',
    defaultMessage: "Enhance and improve your assistant's actions."
  },
  greeting: {
    id: 'components.onboarding.tasks.greeting',
    defaultMessage: 'Customize your greeting'
  },
  greetingDesc: {
    id: 'components.onboarding.tasks.greetingDesc',
    defaultMessage:
      'Welcome your users in a unique way that aligns with your brand.'
  },
  fallback: {
    id: 'components.onboarding.tasks.fallback',
    defaultMessage: 'Create a fallback plan'
  },
  fallbackDesc: {
    id: 'components.onboarding.tasks.fallbackDesc',
    defaultMessage: 'Train your assistant to adapt to specific situations.'
  },
  search: {
    id: 'components.onboarding.tasks.search',
    defaultMessage: 'Set up search'
  },
  searchDesc: {
    id: 'components.onboarding.tasks.searchDesc',
    defaultMessage:
      "Determine how your assistant extracts answers for your users' questions."
  },
  catalog: {
    id: 'components.onboarding.tasks.catalog',
    defaultMessage: 'Explore the skill catalog'
  },
  catalogDesc: {
    id: 'components.onboarding.tasks.catalogDesc',
    defaultMessage:
      'Add pre-built skills to your assistant that would be beneficial to your users.'
  },
  preview: {
    id: 'components.onboarding.tasks.preview',
    defaultMessage: 'Preview & debug'
  },
  previewDesc: {
    id: 'components.onboarding.tasks.previewDesc',
    defaultMessage: 'Enable debug mode when you preview your assistant.'
  },
  chat: {
    id: 'components.onboarding.tasks.chat',
    defaultMessage: 'Customize web chat'
  },
  chatDesc: {
    id: 'components.onboarding.tasks.chatDesc',
    defaultMessage:
      'Design how your assistant shows up in your live environment.'
  },
  channel: {
    id: 'components.onboarding.tasks.channel',
    defaultMessage: 'Set up a channel'
  },
  channelDesc: {
    id: 'components.onboarding.tasks.channelDesc',
    defaultMessage: 'Select the channels you want to deploy your assistant to.'
  },
  agent: {
    id: 'components.onboarding.tasks.agent',
    defaultMessage: 'Set up live agent'
  },
  agentDesc: {
    id: 'components.onboarding.tasks.agentDesc',
    defaultMessage:
      'Integrate live agents to transfer your users to when you edit web chat.'
  },
  publish: {
    id: 'components.onboarding.tasks.publish',
    defaultMessage: 'Publish your AI assistant'
  },
  publishDesc: {
    id: 'components.onboarding.tasks.publishDesc',
    defaultMessage:
      'Choose what live environment(s) you want to publish your assistant to.'
  },
  analytics: {
    id: 'components.onboarding.tasks.analytics',
    defaultMessage: 'Check analytics'
  },
  analyticsDesc: {
    id: 'components.onboarding.tasks.analyticsDesc',
    defaultMessage:
      "Analyze your assistant's performance by reviewing data on specific actions."
  }
});
